<template>
  <div>
    <b-table :current-page="currentPage"
             :fields="fields"
             :items="additionalSampleDeclarations"
             :per-page="perPage"
             head-variant="light"
             hover
             responsive
             striped>
      <template v-if="showFilter"
                v-slot:top-row="{fields}">
        <proposal-filter :id="id"
                         v-model="additionalSampleDeclarations"
                         :fields="fields"
                         :not-include-key="['actions', 'ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(actions)="row">
        <base-icon-button-comment v-if="!elevated"
                                  title="Go to additional sample declaration"
                                  @click="goToDeclaration(row.item)"/>
      </template>
    </b-table>
    <b-table-footer v-model="loading"
                    :current-page="currentPage"
                    :data-length="additionalSampleDeclarations.length"
                    :header-size="footerSize"
                    :pagination="footerPagination"
                    :per-page="perPage"
                    @change-page="changePage">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
  </div>
</template>

<script>
  import BaseIconButtonComment from '@/components/base-components/base-icons/BaseIconButtonComment';
  import BTableFooter from '@/components/BTableFooter';
  import ProposalFilter from '@/components/ProposalFilter';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';

  export default {
    name: 'AdditionalSampleDeclarationList',
    components: {
      BaseColumnOrdinalNumber,
      BaseIconButtonComment,
      ProposalFilter,
      BTableFooter,
      BasePerPageInput,
    },
    props: {
      elevated: {
        type: Boolean,
        default: false,
      },
      footerPagination: {
        type: Boolean,
        default: true,
      },
      footerSize: {
        type: Number,
        default: 1,
        validator: (value) => [1, 2, 3, 4, 5, 6].includes(value),
      },
      loadDataUrl: {
        type: String,
        required: true,
      },
      propFields: {
        type: Array,
        default: () => [],
      },
      showFilter: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        id: 1,
        perPage: 20,
        loading: false,
        currentPage: 1,
        additionalSampleDeclarations: [],
        fields: this.propFields,
      };
    },
    async created() {
      await this.loadData();
    },
    methods: {
      changePage(value) {
        this.currentPage = value;
      },
      goToDeclaration(item) {
        const proposalId = this.getId(item);
        this.$router.push(`/documents/${proposalId}/additional-sample-declarations`);
      },
      async loadData() {
        this.loading = true;
        try {
          const response = await this.axios.get(this.loadDataUrl);
          this.additionalSampleDeclarations = this.processDocuments(response.data);
          this.$emit('setup-proposal', this.additionalSampleDeclarations);
          this.loading = false;
        } catch {
          this.loading = false;
          this.$notify({ type: 'error', title: 'Could not load data' });
        }
      },
      processDocuments(documents) {
        const documentsWithCreatedAt = documents.map(
          (document) => ({
            ...document,
            // eslint-disable-next-line camelcase
            created_at: this.createdAt(document),
          }),
        );
        const sortKey = 'created_at';
        return documentsWithCreatedAt.sort((b, a) => new Date(a[sortKey]) - new Date(b[sortKey]));
      },
    },
  };
</script>

<style scoped>

</style>
